<div class="background">
  <div class="container" *ngIf="invoiceData">
    <div class="row">
      <div class="col-lg-10 offset-md-1 all-card">
        <div class="contact-info valid-info shadow mb-5">
          <!-- Payment Status Header -->
          <div class="payment-status-header" *ngIf="invoiceData">
            <h4 class="invoice-title">Vérification de Paiement</h4>
            <div class="payment-status-badge status-both" >
                <!-- <div class="payment-status-badge" [ngClass]="getPaymentStatusClass()"> -->
              <i class="fa fa-check-circle"></i>
              <span>{{ getPaymentStatusText() }}</span>
            </div>
          </div>

          <!-- Company Information -->
          <div class="mb-4" *ngIf="invoiceData">
            <h5 class="mb-1">{{ invoiceData.company_name || '--' }}</h5>
            <div class="company-numbers mt-3">
              <div class="number-item" *ngIf="invoiceData.cnss_number">
                <span class="number-label">Nº CNSS:</span>
                <span class="number-value">{{ invoiceData.cnss_number || '--' }}</span>
              </div>
              <div class="number-item" *ngIf="invoiceData.cnamgs_number">
                <span class="number-label">Nº CNAMGS:</span>
                <span class="number-value">{{ invoiceData.cnamgs_number || '--' }}</span>
              </div>
            </div>
          </div>

          <!-- Payment Details Section -->
          <div class="payment-details-section" *ngIf="invoiceData">
            <h6 class="section-title">Détails du Paiement</h6>
            
            <div class="payment-details-grid">
              <div class="detail-item">
                <h6>Montant</h6>
                <p class="amount-value">{{ formatAmount(invoiceData.amount) }}</p>
              </div>
              
              <div class="detail-item">
                <h6>Date de Paiement</h6>
                <p>{{ invoiceData.payment_date }}</p>
              </div>
              
              <div class="detail-item">
                <h6>Mode de Paiement</h6>
                <p>{{ invoiceData.mode_of_payment || '--' }}</p>
              </div>
              
              <div class="detail-item">
                <h6>Numéro de Transaction</h6>
                <p class="">{{ invoiceData.transaction_no || '--' }}</p>
                <!-- <p class="transaction-no">{{ invoiceData.transaction_no || '--' }}</p> -->
              </div>
            </div>
          </div>

          <!-- Payment Status Details -->
          <div class="payment-status-details mt-5" *ngIf="invoiceData">
            <h6 class="section-title">Statut de Paiement</h6>
            <div class="status-details-grid">
              <div class="status-item-container">
                <h6>CNSS</h6>
                <div class="status-item" *ngIf="hasCNSSPayment()">
                  <div class="status-icon cnss-icon">
                    <i class="fa fa-check-circle"></i>
                  </div>
                  <div class="status-content">
                  
                    <p>Paiement effectué</p>
                  </div>
                </div>
              </div>
              
              <div class="status-item-container">
                <h6>CNAMGS</h6>
                <div class="status-item" *ngIf="hasCNAMGSPayment()">
                  <div class="status-icon cnamgs-icon">
                    <i class="fa fa-check-circle"></i>
                  </div>
                  <div class="status-content">
                    
                    <p>Paiement effectué</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="invoiceData == '' || invoiceData == null">
    <div class="row">
      <div class="col-lg-10 offset-md-1 all-card">
        <div class="contact-info valid-info shadow mb-5">
          <img src="assets/images/not-valid.png">
          <span class="anpi_green">Paiement non trouvé</span>
          <h5 class="mb-3">Désolé, cette facture de paiement n'est pas vérifiée</h5>
        </div>
      </div>
    </div>
  </div>

  <!-- Contact Section -->
  <section>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-md-3">
          <div class="validate-form">
            <h3>Si vous avez des questions, veuillez nous contacter</h3>
          </div>
          <div class="contact-info shadow mb-5">
            <h5 class="mb-3">Portail Unique de Prévoyance Sociale (PUPS)</h5>
            <!-- 104 Rue Gustave ANGUILE ,<br />
            Immeuble Serena<br />
            B.P 3403<br />
            Email: contact@ccpsgabon.ga<br />
            Tel : +241 (0) 77 94 26 29 -->
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
